// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import BlockActor from "./BlockActor";

export default class GenericBlockActor extends BlockActor {
  public override load() {}
}
